import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import type { RootState } from "./store"

interface ConfigurationState {
    country: string | undefined
}

const initialState: ConfigurationState = {
    country: undefined
}

export const configurationSlice = createSlice({
    name: "configuration",
    initialState,
    reducers: {
        setCountry: (state, action: PayloadAction<string>): void => {
            state.country = action.payload
        }
    }
})

export const { setCountry } = configurationSlice.actions

export const selectCountry = (state: RootState) => state.configuration.country

export default configurationSlice.reducer
